import CheckoutNewSchoolWrapper from './CheckoutNewSchoolWrapper.component';

export default CheckoutNewSchoolWrapper;